__turbopack_context__.v({
  "evidenceFlow": "bastion-roadmap-stage-module__rNiH3a__evidenceFlow",
  "featureRoadmapBridge": "bastion-roadmap-stage-module__rNiH3a__featureRoadmapBridge",
  "featureRoadmapBridgeCleared": "bastion-roadmap-stage-module__rNiH3a__featureRoadmapBridgeCleared",
  "featureRoadmapBridgeVisible": "bastion-roadmap-stage-module__rNiH3a__featureRoadmapBridgeVisible",
  "featureRoadmapTitle": "bastion-roadmap-stage-module__rNiH3a__featureRoadmapTitle",
  "featureRoadmapTitleDocked": "bastion-roadmap-stage-module__rNiH3a__featureRoadmapTitleDocked",
  "featureRoadmapTitleVisible": "bastion-roadmap-stage-module__rNiH3a__featureRoadmapTitleVisible",
  "foundationAiCore": "bastion-roadmap-stage-module__rNiH3a__foundationAiCore",
  "foundationAiInputs": "bastion-roadmap-stage-module__rNiH3a__foundationAiInputs",
  "foundationAiPaths": "bastion-roadmap-stage-module__rNiH3a__foundationAiPaths",
  "foundationAiReport": "bastion-roadmap-stage-module__rNiH3a__foundationAiReport",
  "foundationArrow": "bastion-roadmap-stage-module__rNiH3a__foundationArrow",
  "foundationCard": "bastion-roadmap-stage-module__rNiH3a__foundationCard",
  "foundationLines": "bastion-roadmap-stage-module__rNiH3a__foundationLines",
  "foundationNodes": "bastion-roadmap-stage-module__rNiH3a__foundationNodes",
  "foundationRow": "bastion-roadmap-stage-module__rNiH3a__foundationRow",
  "foundationRowDocked": "bastion-roadmap-stage-module__rNiH3a__foundationRowDocked",
  "foundationRowReplaced": "bastion-roadmap-stage-module__rNiH3a__foundationRowReplaced",
  "foundationSignal": "bastion-roadmap-stage-module__rNiH3a__foundationSignal",
  "foundationUnit": "bastion-roadmap-stage-module__rNiH3a__foundationUnit",
  "foundationVisual": "bastion-roadmap-stage-module__rNiH3a__foundationVisual",
  "foundationWorkflowTile": "bastion-roadmap-stage-module__rNiH3a__foundationWorkflowTile",
  "roadmapArrowDrift": "bastion-roadmap-stage-module__rNiH3a__roadmapArrowDrift",
  "roadmapCanvas": "bastion-roadmap-stage-module__rNiH3a__roadmapCanvas",
  "roadmapInstant": "bastion-roadmap-stage-module__rNiH3a__roadmapInstant",
  "roadmapMilestone": "bastion-roadmap-stage-module__rNiH3a__roadmapMilestone",
  "roadmapMilestoneActive": "bastion-roadmap-stage-module__rNiH3a__roadmapMilestoneActive",
  "roadmapMilestones": "bastion-roadmap-stage-module__rNiH3a__roadmapMilestones",
  "roadmapProduct": "bastion-roadmap-stage-module__rNiH3a__roadmapProduct",
  "roadmapProductActive": "bastion-roadmap-stage-module__rNiH3a__roadmapProductActive",
  "roadmapProductConnector": "bastion-roadmap-stage-module__rNiH3a__roadmapProductConnector",
  "roadmapProductIcon": "bastion-roadmap-stage-module__rNiH3a__roadmapProductIcon",
  "roadmapProducts": "bastion-roadmap-stage-module__rNiH3a__roadmapProducts",
  "roadmapRail": "bastion-roadmap-stage-module__rNiH3a__roadmapRail",
  "roadmapRailVisible": "bastion-roadmap-stage-module__rNiH3a__roadmapRailVisible",
  "roadmapSectionTitle": "bastion-roadmap-stage-module__rNiH3a__roadmapSectionTitle",
  "roadmapTitleActive": "bastion-roadmap-stage-module__rNiH3a__roadmapTitleActive",
  "roadmapTitleLayer": "bastion-roadmap-stage-module__rNiH3a__roadmapTitleLayer",
  "roadmapTitlePast": "bastion-roadmap-stage-module__rNiH3a__roadmapTitlePast",
  "snapshotCard": "bastion-roadmap-stage-module__rNiH3a__snapshotCard",
  "snapshotConnector": "bastion-roadmap-stage-module__rNiH3a__snapshotConnector",
  "snapshotDetail": "bastion-roadmap-stage-module__rNiH3a__snapshotDetail",
  "snapshotMarketCard": "bastion-roadmap-stage-module__rNiH3a__snapshotMarketCard",
  "snapshotPipeline": "bastion-roadmap-stage-module__rNiH3a__snapshotPipeline",
  "snapshotPipelineStripped": "bastion-roadmap-stage-module__rNiH3a__snapshotPipelineStripped",
  "snapshotPipelineTransferred": "bastion-roadmap-stage-module__rNiH3a__snapshotPipelineTransferred",
  "snapshotTitlePlaceholder": "bastion-roadmap-stage-module__rNiH3a__snapshotTitlePlaceholder",
  "snapshotVisualPlaceholder": "bastion-roadmap-stage-module__rNiH3a__snapshotVisualPlaceholder",
});
